module.exports = __webpack_public_path__ + "images/emoji/droplet.a5e8161908ecc8a8f91a.png";